import React from 'react';

const SubHeaderBlock = ({ block }) => {
  if (!block.text) return null;

  const getStyleClasses = () => {
    const style = block.style || {};
    const classes = [];

   
    if (style.fontSize === 'xl') classes.push('text-xl');
    else if (style.fontSize === 'lg') classes.push('text-lg');
    else if (style.fontSize === '2xl') classes.push('text-2xl');
    else classes.push('text-lg');

   
    if (style.fontWeight === 'bold') classes.push('font-bold');
    else if (style.fontWeight === 'semibold') classes.push('font-semibold');
    else classes.push('font-semibold');

    
    if (style.color === 'gray-800') classes.push('text-gray-800');
    else if (style.color === 'primary') classes.push('text-primary');
    else if (style.color === 'white') classes.push('text-white');
    else classes.push('text-gray-800');

    
    if (style.marginTop) classes.push(style.marginTop);
    if (style.marginBottom) classes.push(style.marginBottom);
    else classes.push('mb-4');

    
    if (style.underline) classes.push('underline');

    return classes.join(' ');
  };

  const isBanner = block.style?.backgroundColor || block.style?.banner;
  const bannerClasses = isBanner 
    ? 'px-4 py-2 rounded-lg text-white inline-block'
    : '';

  const bannerStyle = isBanner && block.style?.backgroundColor
    ? { backgroundColor: block.style.backgroundColor }
    : isBanner && !block.style?.backgroundColor
    ? { backgroundColor: '#3B82F6' }
    : {};

  return (
    <h3 className={`${getStyleClasses()} ${bannerClasses}`} style={bannerStyle}>
      {block.text}
    </h3>
  );
};

export default SubHeaderBlock;

